// extracted by mini-css-extract-plugin
export default {"talentUpdateModal":"UpdateModal_talentUpdateModal__kyCRe","formTitle":"UpdateModal_formTitle__3cm-n","talentUpdateBody":"UpdateModal_talentUpdateBody__GYbw-"};